import api from '../../../api/_dossier-medical'
import api_exam from '../../../api/_examen'
import api_consultation from '../../../api/_consultation'
import api_protocoles from '../../../api/consultations/_protocole-soins'

export default {
    getConsultationAnamneses(data) {
        return new Promise((resolve, reject) => {
            api.getConsultationAnamneses(data).then(
                response => {
                    if (data.est_en_cours == true) {
                        resolve(response)
                    } else {
                        resolve(response)
                    }
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getExamensAttenteInterpretation(data) {
        return new Promise((resolve, reject) => {
            api_exam.getExamensAttenteInterpretation(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveExamenInterpretation(data) {
        return new Promise((resolve, reject) => {
            api_exam.saveExamenInterpretation(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getHistoriqueResultatExamen(data) {
        return new Promise((resolve, reject) => {
            api_exam.getHistoriqueResultatExamen(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveClicheExamen(data) {
        return new Promise((resolve, reject) => {
            api_exam.saveClicheExamen(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getConsultationsEnAttente(data) {
        return new Promise((resolve, reject) => {
            api_consultation.getConsultationAttente(data).then(response => {
                resolve(response)
            }, error => {
                reject(error)
            })
        })
    },

    getSuitesSoins(data) {
        return new Promise((resolve, reject) => {
            api_consultation.getSuitesSoins(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getPatientsAdmissionEnCours(data) {
        return new Promise((resolve, reject) => {
            api_protocoles.getPatientsAdmissionEnCours(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getTraitementEnCours(data) {
        return new Promise((resolve, reject) => {
            api_protocoles.getTraitementEnCours(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    editProtocoleData(data) {
        return new Promise((resolve, reject) => {
            api_protocoles.editProtocoleData(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    deleteProtocoleItem(data) {
        return new Promise((resolve, reject) => {
            api_protocoles.deleteProtocoleItem(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },
}